module.exports = __webpack_public_path__ + "r.no2.83583edf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/r.no2.jpg
// module id = PvuK
// module chunks = 0